import { render, staticRenderFns } from "./PhishingWarning.vue?vue&type=template&id=0378b788&scoped=true"
import script from "./PhishingWarning.vue?vue&type=script&lang=js"
export * from "./PhishingWarning.vue?vue&type=script&lang=js"
import style0 from "./PhishingWarning.vue?vue&type=style&index=0&id=0378b788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0378b788",
  null
  
)

export default component.exports